<template>
  <div class="add-singleBrand">
    <div class="single-wrap" :style="{height: (fullHeight - 230) + 'px'}">
      <i class="el-icon-close" @click="hideSingleBrand"></i>
      <h3>{{editText}}签约品牌</h3>
      <div class="projectName">{{projectName}}</div>
      <div class="input-wrap">
        <div class="singlebrnad-left">
          <div class="single-box">
            <p><i class="mustFill">*</i>签约品牌</p>
            <div class="search-wrap">
              <el-input
                :class="[isEdit ? 'is-disabled': '']"
                type="text"
                v-model="brandKeyWord"
                class="searchBrand"
                @input="searchInput"
                @focus="hideBusinessType"
                @blur="hideKeyworld"
                :disabled="isEdit"
                placeholder="请输入你想添加的品牌名称"></el-input>
              <div class="search-list" v-show="brandKeyWordListShow">
                <ul>
                  <li
                    v-show="brandKeyWordList.length > 0"
                    v-for="(item, index) in brandKeyWordList"
                    :key="index"
                    @click="addSingleBrand(item)">{{item.brandName}}</li>
                  <li v-show="brandKeyWordList.length === 0 && !brandLoad">无相关品牌数据！</li>
                </ul>
              </div>
            </div>
          </div>
          <div class="single-box">
            <p>
              <i v-if="isRent === '1'" class="mustFill">*</i>计租方式：
              <el-tooltip class="item" effect="dark" placement="bottom">
                <i class="icon-font icon-question"></i>
                <div slot="content">计租方式为扣点的品牌租金收益将按照项目的平均标准租金进行测算</div>
              </el-tooltip>
            </p>
            <div class="search-wrap">
              <el-select
                v-model="rentSelectStr"
                @change="changeSelectRent"
                popper-class="floorSelectPoper"
                placeholder="请选择">
                <el-option
                  v-for="item in rentList"
                  :key="item.value"
                  :label="item.label"
                  :value="item">
                </el-option>
              </el-select>
            </div>
            <div class="single-box" v-if="rentCur === 2">
              <p><i v-if="isRent === '1'" class="mustFill">*</i>扣点比例：</p>
              <div class="search-wrap">
                <el-input
                  type="number"
                  class="rentArea-input"
                  v-model="rentPercent"
                  placeholder="请输入扣点比例"></el-input>
                <i class="percentage" style="top: 10px;">%</i>
              </div>
            </div>
            <div class="search-wrap" v-if="rentCur !== 2">
              <p><i v-if="isRent === '1'" class="mustFill">*</i>签约租金：</p>
              <el-input
                type="number"
                v-model="rentPrice"
                @keyup.native="number"
                class="searchBrand"
                placeholder="请输入月度租金标准"></el-input>
              <i class="percentage">元/月/m²</i>
            </div>
          </div>
          <div class="single-box">
            <p><i v-if="isLease === '1'" class="mustFill">*</i>租赁时间</p>
            <div class="search-wrap">
              <el-date-picker
                v-model="rentTime"
                type="daterange"
                clearable
                @change="changeRent"
                value-format='yyyy-MM-dd'
                start-placeholder="开始日期"
                end-placeholder="结束日期">
              </el-date-picker>
            </div>
          </div>
        </div>
        <div class="singlebrnad-right">
          <div class="single-box">
            <p><i class="mustFill">*</i>签约铺位：</p>
            <div class="search-wrap">
              <el-cascader
                popper-class="floorCascaderPoper"
                v-model="floorVal"
                placeholder="请选择签约铺位"
                :options="floorArr"
                filterable
                @change="getFloorNumber"
              ></el-cascader>
            </div>
          </div>
          <div class="single-box">
            <p><i v-if="isArea === '1'" class="mustFill">*</i>租赁面积：</p>
            <div class="search-wrap">
              <el-input
                type="number"
                v-model="rentArea"
                @keyup.native="number"
                class="rentArea-input"
                placeholder="请输入租金计算面积"></el-input>
              <i class="percentage">m²</i>
            </div>
          </div>
          <div class="single-box" v-if="rentCur === 3">
            <p><i v-if="isRent === '1'" class="mustFill">*</i>扣点比例：</p>
            <div class="search-wrap">
              <el-input
                type="number"
                class="rentArea-input"
                v-model="rentPercent"
                placeholder="请输入扣点比例"></el-input>
              <i class="percentage">%</i>
            </div>
          </div>
          <div class="single-box" v-if="rentCur === 2">
            <p><i v-if="isRent === '1'" class="mustFill">*</i>预估租金：</p>
            <el-input
              type="number"
              v-model="rentPrice"
              @keyup.native="number"
              class="searchBrand"
              placeholder="请输入月度预估租金"></el-input>
            <i class="percentage">元/月/m²</i>
          </div>
          <div class="single-box">
            <p>免租时间</p>
            <div class="search-wrap">
              <el-date-picker
                v-model="rentFreeTime"
                type="daterange"
                clearable
                @change="changeFree"
                value-format='yyyy-MM-dd'
                start-placeholder="开始日期"
                end-placeholder="结束日期">
              </el-date-picker>
            </div>
          </div>
        </div>
      </div>
      <div class="clearfix"></div>
      <div class="sing-remarks">
        <p>租赁补充：</p>
        <el-input
          type="textarea"
          v-model="rentRemark"
          placeholder="请补充其他租赁重要协议内容，诸如装补等"></el-input>
      </div>
      <div class="btn-wrap">
        <span class="cancal" @click="hideSingleBrand">取消</span>
        <span @click="determine('sure')">保存</span>
        <span v-if="edit === 0" @click="determine('next')">保存并继续新增</span>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/api'
export default {
  data () {
    return {
      isEdit: false,
      editText: '添加',
      rentCur: 3,
      brandLoad: true,
      brandKeyWord: '',
      brandKeyWordList: [],
      brandKeyWordListShow: false,
      rentSelectStr: '固租+扣点(取其高)',
      rentList: [{ label: '固租+扣点(取其高)', value: 3 }, { label: '固租', value: 1 }, { label: '扣点', value: 2 }],
      rentTime: [],
      rentBeg: '',
      rentEnd: '',
      rentFreeTime: [],
      freeBeg: '',
      freeEnd: '',
      rentPrice: '',
      rentPercent: '',
      floorVal: [],
      selectObj: {},
      storeVal: [],
      id: '',
      rentRemark: '',
      isRent: '0',
      isLease: '0',
      isArea: '0',
      rentArea: '',
      fullHeight: 0,
      floorArr: []
    }
  },
  props: {
    projectId: {
      type: Number
    },
    projectName: {
      type: String
    },
    brandDetails: {
      type: Object
    },
    edit: {
      type: Number
    },
    singedIdx: {
      type: Number
    }
  },
  watch: {
    fullHeight (val) {
      if (!this.timer) {
        this.fullHeight = val
        this.timer = true
        const that = this
        setTimeout(function () {
          that.timer = false
        }, 400)
      }
    }
  },
  beforeDestroy () {
    window.removeEventListener('click', this.closeClick)
  },
  mounted () {
    console.log(this.edit)
    // console.log(this.projectId)
    // console.log(this.brandDetails)
    const that = this
    window.onresize = () => {
      return (() => {
        window.fullHeight = document.documentElement.clientHeight
        that.fullHeight = window.fullHeight
      })()
    }
    window.addEventListener('click', this.closeClick)
    if (this.projectId) {
      this.getlistFloor(this.projectId)
    }
    if (this.edit === 1) {
      this.$nextTick(() => {
        this.editText = '编辑'
        this.selectObj = this.brandDetails
        this.brandKeyWord = this.brandDetails.brandName
        this.rentCur = this.brandDetails.rentWay
        this.rentSelectStr = this.rentCur === 1 ? '固租' : (this.rentCur === 2 ? '扣点' : '扣点+固租(取其高)')
        this.rentRemark = this.brandDetails.rentRemark
        this.rentArea = this.brandDetails.rentArea
        this.rentPrice = this.brandDetails.rentPrice
        this.rentPercent = this.brandDetails.rentPercent
        this.rentTime.push(this.brandDetails.rentBeg)
        this.rentTime.push(this.brandDetails.rentEnd)
        this.rentFreeTime.push(this.brandDetails.freeBeg)
        this.rentFreeTime.push(this.brandDetails.freeEnd)
        this.floorVal.push(this.brandDetails.floor)
        this.floorVal.push(this.brandDetails.berthId)
        this.berthId = this.brandDetails.berthId
        this.id = this.brandDetails.signedId || this.brandDetails.id
        if (!this.brandDetails.rentArea) {
          this.getBerthArea()
        }
      })
    } else if (this.edit === 0) {
      this.editText = '添加'
      if (this.brandDetails) {
        this.floorVal.push(this.brandDetails.floor)
        this.floorVal.push(this.brandDetails.berthId)
        this.berthId = this.brandDetails.berthId
        if (this.berthId) {
          this.getBerthArea()
        }
      }
    } else if (this.edit === 6) {
      this.floorVal.push(this.brandDetails.berth.floor)
      this.floorVal.push(this.brandDetails.berth.berthId)
      this.berthId = this.brandDetails.berth.berthId
      this.getBerthArea()
    } else if (this.edit === 7) { // 地图上点击编辑签约品牌信息
      this.editText = '编辑'
      console.log(this.brandDetails)
      this.selectObj = this.brandDetails.signedBrands[this.singedIdx].brand
      this.brandKeyWord = this.brandDetails.signedBrands[this.singedIdx].brand.brandName
      this.rentCur = this.brandDetails.signedBrands[this.singedIdx].rentWay
      this.rentSelectStr = this.rentCur === 1 ? '固租' : (this.rentCur === 2 ? '扣点' : '扣点+固租(取其高)')
      this.rentRemark = this.brandDetails.signedBrands[this.singedIdx].rentRemark
      this.rentArea = this.brandDetails.signedBrands[this.singedIdx].rentArea
      this.rentPrice = this.brandDetails.signedBrands[this.singedIdx].rentPrice
      this.rentPercent = this.brandDetails.signedBrands[this.singedIdx].rentPercent
      this.rentTime.push(this.brandDetails.signedBrands[this.singedIdx].rentBeg ? this.brandDetails.signedBrands[this.singedIdx].rentBeg : '')
      this.rentTime.push(this.brandDetails.signedBrands[this.singedIdx].rentEnd ? this.brandDetails.signedBrands[this.singedIdx].rentEnd : '')
      this.rentFreeTime.push(this.brandDetails.signedBrands[this.singedIdx].freeBeg ? this.brandDetails.signedBrands[this.singedIdx].freeBeg : '')
      this.rentFreeTime.push(this.brandDetails.signedBrands[this.singedIdx].freeEnd ? this.brandDetails.signedBrands[this.singedIdx].freeEnd : '')
      this.floorVal.push(this.brandDetails.berth.building)
      this.floorVal.push(this.brandDetails.berth.floor)
      this.floorVal.push(this.brandDetails.berth.berthId)
      this.berthId = this.brandDetails.berth.berthId
      this.id = this.brandDetails.signedBrands[this.singedIdx].id
      if (!this.brandDetails.signedBrands[this.singedIdx].rentArea) {
        this.getBerthArea()
      }
    } else if (this.edit === 2) {
      this.floorVal.push(this.brandDetails.floor)
      this.floorVal.push(this.brandDetails.berthId)
      this.berthId = this.brandDetails.berthId
      if (this.berthId) {
        this.getBerthArea()
      }
    }
    this.getSetting()
  },
  methods: {
    closeClick (e) {
      if (e.target.className === 'add-singleBrand') {
        this.hideSingleBrand()
      }
    },
    number () {
      this.rentPrice = this.rentPrice.replace(/[^.\d]/g, '')
      this.rentPrice = this.rentPrice.replace('.', '')
    },
    getlistFloor (id) {
      this.axios.post(api.getFloorBuilding, { projectId: id })
        .then((res) => {
          this.floorArr = res.data.data
        })
    },
    getSetting () {
      this.axios.post(api.mngConfigSetting, { biz: 'berth_signed_form' })
        .then((res) => {
          this.isRent = res.data.data[0].value
          this.isLease = res.data.data[1].value
          this.isArea = res.data.data[2].value
        })
    },
    searchInput () {
      this.fetchBrandByKeyworld()
    },
    getFloorNumber (value) {
      this.floorVal = value
      this.berthId = value[2]
      if (this.berthId) {
        this.getBerthArea()
      }
    },
    getBerthArea () {
      this.axios.post(api.getByBerthId, { berthId: this.berthId })
        .then((res) => {
          this.rentArea = res.data.data.useArea
        })
    },
    changeSelectRent (item) {
      if (item.value) {
        this.rentCur = item.value
      }
    },
    rentClick (index) {
      this.rentCur = index
    },
    hideSingleBrand () {
      this.$emit('hideSingle')
    },
    hideKeyworld () {
      // if ((this.brandKeyWordList && this.brandKeyWordList.length === 0) || this.brandKeyWord === '') {
      //   this.brandKeyWord = ''
      // }
      if (!this.selectObj.gbid) {
        this.brandKeyWord = ''
        this.businessTypeShow = false
      }
    },
    hideBusinessType () {
      if (this.brandKeyWord === '') {
        this.brandKeyWord = ''
        this.businessTypeShow = false
      } else {
        this.brandKeyWordListShow = true
      }
    },
    fetchBrandByKeyworld () {
      let brandKeyWord = ''
      this.brandLoad = true
      if (this.brandKeyWord !== '' && this.brandKeyWord !== '请输入你想添加的品牌名称') {
        brandKeyWord = this.brandKeyWord
      }
      if (brandKeyWord) {
        this.brandKeyWordList = []
        this.businessTypeShow = false
        this.brandKeyWordListShow = true
        this.axios.post(api.searchBrandList, { brandName: this.brandKeyWord })
          .then((res) => {
            this.brandLoad = false
            if (res.data.code === 0) {
              this.currentKeywordBrand = ''
              this.brandKeyWordList = res.data.data.map((item) => {
                if (item.brandName === this.brandKeyWord) {
                  this.currentKeywordBrand = item
                }
                // 处理默认选中状态为true
                item.active = true
                return item
              })
            }
          })
      } else {
        this.brandKeyWordListShow = false
      }
    },
    changeRent (val) {
      if (val) {
        this.rentBeg = val[0]
        this.rentEnd = val[1]
      } else {
        this.rentTime = ''
        this.rentBeg = ''
        this.rentEnd = ''
      }
    },
    changeFree (val) {
      if (val) {
        this.freeBeg = val[0]
        this.freeEnd = val[1]
      } else {
        this.rentFreeTime = ''
        this.freeBeg = ''
        this.freeEnd = ''
      }
    },
    addSingleBrand (item) {
      this.selectObj = item
      this.brandKeyWordListShow = false
      this.brandKeyWord = item.brandName
    },
    determine (type) {
      if (!this.selectObj.gbid) {
        this.$message({
          type: 'warning',
          message: '签约品牌不能为空！'
        })
        return false
      }
      if (this.berthId === '') {
        this.$message({
          type: 'warning',
          message: '签约铺位不能为空！'
        })
        return false
      }
      if (this.rentRemark.length > 200) {
        this.$message({
          type: 'warning',
          message: '租赁补充不能超过200字！'
        })
        return false
      }
      // 选择成功后清空所有填写项
      const data = {}
      data.freeBeg = this.freeBeg
      data.freeEnd = this.freeEnd
      data.rentBeg = this.rentBeg
      data.rentEnd = this.rentEnd
      data.rentArea = this.rentArea
      data.rentWay = this.rentCur
      if (this.rentCur === 1) {
        data.rentPercent = ''
        data.rentPrice = this.rentPrice
      } else if (this.rentCur === 2) {
        data.rentPercent = this.rentPercent
        data.rentPrice = this.rentPrice
      } else if (this.rentCur === 3) {
        data.rentPercent = this.rentPercent
        data.rentPrice = this.rentPrice
      }
      data.berthId = this.berthId
      data.brandId = this.selectObj.brandId
      data.id = this.selectObj.id
      data.rentRemark = this.rentRemark
      if (this.edit === 7 || this.edit === 1) {
        data.id = this.id
      }
      data.projectId = this.projectId
      data.gbid = this.selectObj.gbid
      if (this.edit === 0) {
        this.axios.post(api.byGbidSynchronization, { gbid: this.selectObj.gbid, projectId: this.projectId })
          .then((res) => {
            if (res.data.data) {
              this.$confirm('当前签约品牌存在招商任务，是否同步修改招商任务为已签约', '提示', {
                confirmButtonText: '同步',
                cancelButtonText: '不同步',
                type: 'warning',
                customClass: 'invitePosition'
              }).then(() => {
                data.taskId = res.data.data.id
                this.comfigFunc(data, type)
              }).catch(() => {
                this.comfigFunc(data, type)
              })
            } else {
              this.comfigFunc(data, type)
            }
          })
      } else {
        this.comfigFunc(data, type)
      }
    },
    comfigFunc (data, type) {
      this.axios.post(api.saveSingleBrand, data)
        .then((res) => {
          if (res.data.code === 0) {
            if (this.edit === 3 || this.edit === 4 || this.edit === 5) {
              this.$emit('refreshMap')
            }
            this.$message({
              type: 'success',
              message: '添加成功！'
            })
            if (type === 'next') {
              this.$emit('addSuccessFunc')
            } else {
              this.$emit('addSuccessFunc', true)
            }
            this.brandKeyWord = ''
            this.selectObj = {}
            this.freeBeg = ''
            this.freeEnd = ''
            this.rentBeg = ''
            this.rentEnd = ''
            this.rentCur = 1
            this.rentPercent = ''
            this.rentPrice = ''
            this.floorVal = []
            this.storeVal = ''
            this.rentFreeTime = ''
            this.rentArea = ''
            this.rentTime = ''
            this.rentRemark = ''
          } else {
            // this.$message({
            //   type: 'warning',
            //   message: res.data.msg + '！'
            // })
          }
        })
    }
  }
}
</script>

<style lang="stylus" scoped>
.add-singleBrand
  position fixed
  left 0
  top 0
  bottom 0
  right 0
  background rgba(0,0,0,.5)
  z-index 1111
  .single-wrap
    position absolute
    left 50%
    margin-left -450px
    top 80px
    width 860px
    height 610px
    overflow-y auto
    background #ffffff
    border-radius 6px
    padding 30px 20px
    z-index 1111
    .el-icon-close
      position absolute
      right 20px
      top 15px
      color #D9D9D9
      cursor pointer
    h3
      color #333
      font-weight bold
.input-wrap
  .singlebrnad-left
    float left
    width 48%
    .single-box
      p
        color #333
        font-weight 500
        margin-bottom 10px
        margin-top 25px
        font-size 14px
        span
          font-size 14px
          font-weight 400
          color #999
          padding 3px 5px
          border 1px solid rgba(217,217,217,.5)
          cursor pointer
          &.g-rent
            border-radius 2px 0px 0px 2px
          &.l-rent
            border-radius 0px 2px 2px 0px
          &.active
            background #FFA134
            color #fff
            border 1px solid #FFA134
      .search-wrap
        position relative
        .referInput
          margin-top 10px
        input
          width 380px
          height 32px
          line-height 32px
          padding-left 12px
          border-radius 2px
          border 1px solid rgba(236,236,236,1)
          cursor pointer
          font-size 14px
          box-sizing border-box
        .percentage
          position absolute
          right 47px
          top 36px
          color #333
          font-weight 400
          font-size 12px
      .search-wrap2
        position relative
        input
          width 189px
          height 32px
          line-height 32px
          padding-left 12px
          border-radius 2px
          border 1px solid rgba(236,236,236,1)
          font-size 14px
          box-sizing border-box
        .unit1
          position absolute
          right 232px
          top 10px
          color #333
          font-weight 400
          font-size 12px
        .unit2
          position absolute
          right 49px
          top 10px
          color #333
          font-weight 400
          font-size 12px
        .percentage
          position absolute
          right 232px
          top 10px
          color #333
          font-weight 400
          font-size 12px
        .percentage2
          position absolute
          right 40px
          top 10px
          color #333
          font-weight 400
          font-size 12px
  .singlebrnad-right
    float right
    width 44%
    .single-box
      position relative
      p
        color #333
        font-weight 500
        margin-bottom 10px
        margin-top 25px
        font-size 14px
      .search-wrap
        position relative
        .percentage
          position absolute
          right 12px
          top 10px
          color #333
          font-weight 400
          font-size 12px
      .percentage
        position absolute
        right 12px
        top 36px
        color #333
        font-weight 400
        font-size 12px
.btn-wrap
  text-align center
  margin-top 20px
  span
    display inline-block
    width 200px
    height 40px
    line-height 40px
    text-align center
    color #fff
    background #FFA134
    font-size 16px
    font-weight 400
    border-radius 4px
    margin 0 10px
    cursor pointer
    &.cancal
      background #ffffff
      color #FFA134
      border 1px solid #FFA134
.search-list
  position absolute
  top 35px
  left 0px
  width 392px
  max-height 320px
  padding-top 1px
  z-index 11111
  background-color #fff
  overflow-y scroll
  box-shadow 2px 4px 10px #888
  border-radius 5px
  border-top 1px solid #ccc
  li
    height 36px
    line-height 36px
    text-align left
    text-indent 24px
    border-bottom 1px solid #cccccc
    font-size 14px
    cursor pointer
    &:hover
      color #FFA134
.single-wrap,
.search-list
  &::-webkit-scrollbar {
    width: 6px;
  }
  &::-webkit-scrollbar-track {
      // background-color: #f2f2f2;
      border-radius 10px
  } /* 滚动条的滑轨背景颜色 */

  &::-webkit-scrollbar-thumb {
      background-color: #5f5f5f;
      border-radius 10px
  } /* 滑块颜色 */

  &::-webkit-scrollbar-button {
      // background-color: #000;
  } /* 滑轨两头的监听按钮颜色 */

  &::-webkit-scrollbar-corner {
      // background-color: black;
  } /* 横向滚动条和纵向滚动条相交处尖角的颜色 */
.sing-remarks
  margin-top 20px
  p
    color #333
    font-size 14px
    margin-bottom 10px
  textarea
    box-sizing border-box
    width 100%
    height 90px
    resize none
    margin-top 10px
    border-radius 3px
    padding 10px
    font-size 14px
    appearance none
    border-style solid
.is-disabled
  background-color #f9f9f9
.projectName
  width 100%
  background rgba(255,161,52,0.1)
  color #995F1D
  margin-top 14px
  height 40px
  line-height 40px
  font-size 16px
  padding-left 22px
  box-sizing border-box
.rentArea-input
  width 380px
  height 32px
  line-height 32px
  border-radius 2px
  cursor pointer
  font-size 14px
  box-sizing border-box
.el-textarea__inner
  color #999
</style>
